var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgTrash(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 14,
    height: 16,
    viewBox: "0 0 14 16",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "trash",
    d: "M5.091,13V5.667A.333.333,0,0,0,5,5.427a.3.3,0,0,0-.229-.094H4.136a.3.3,0,0,0-.229.094.333.333,0,0,0-.09.24V13a.333.333,0,0,0,.09.24.3.3,0,0,0,.229.094h.636A.3.3,0,0,0,5,13.24.333.333,0,0,0,5.091,13Zm2.545,0V5.667a.333.333,0,0,0-.09-.24.3.3,0,0,0-.229-.094H6.681a.3.3,0,0,0-.229.094.333.333,0,0,0-.09.24V13a.333.333,0,0,0,.09.24.3.3,0,0,0,.229.094h.636a.3.3,0,0,0,.229-.094A.333.333,0,0,0,7.636,13Zm2.545,0V5.667a.333.333,0,0,0-.09-.24.3.3,0,0,0-.229-.094H9.227A.3.3,0,0,0,9,5.427a.333.333,0,0,0-.09.24V13a.333.333,0,0,0,.09.24.3.3,0,0,0,.229.094h.636a.3.3,0,0,0,.229-.094A.333.333,0,0,0,10.181,13ZM4.772,2.667H9.227L8.749,1.448a.28.28,0,0,0-.169-.115H5.429a.28.28,0,0,0-.169.115ZM14,3v.667a.333.333,0,0,1-.09.24A.3.3,0,0,1,13.681,4h-.954v9.875a2.439,2.439,0,0,1-.467,1.495,1.369,1.369,0,0,1-1.123.63H2.863a1.38,1.38,0,0,1-1.123-.609,2.353,2.353,0,0,1-.467-1.474V4H.318A.3.3,0,0,1,.09,3.906.333.333,0,0,1,0,3.667V3a.333.333,0,0,1,.09-.24.3.3,0,0,1,.229-.094H3.39l.7-1.74A1.431,1.431,0,0,1,4.624.271,1.357,1.357,0,0,1,5.409,0H8.591a1.361,1.361,0,0,1,.786.271,1.428,1.428,0,0,1,.537.656l.7,1.74h3.072a.3.3,0,0,1,.229.094A.333.333,0,0,1,14,3Z",
    fill: "#ff2f2f"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgTrash);
export default __webpack_public_path__ + "static/media/trash.faca98993750f274e165f193a0efbdab.svg";
export { ForwardRef as ReactComponent };